// reorder.js — Listen per Ziehen umsortieren (Zeiger-Ereignisse, funktioniert mit Touch).
//   makeReorderable(listEl, { item: '.row', handle: '[data-drag]', onDrop: (from, to) => … })
// Während des Ziehens folgt die Zeile dem Finger, die anderen weichen per Feder-Übergang aus.
// Zuhörer für move/up hängen am FENSTER: ein Umsortieren im DOM würde sonst die Zeigererfassung lösen
// (Lehre aus der Hue-App, siehe CLAUDE.md des Smart-Home-Projekts).
import { reducedMotion } from '../core/dom.js';

/** Zielindex aus der Mitte der gezogenen Zeile und den Mitten der anderen (rein, testbar). */
export function targetIndex(centers, from, y) {
  let to = from;
  for (let i = 0; i < centers.length; i++) {
    if (i === from) continue;
    if (i < from && y < centers[i]) { to = Math.min(to, i); }
    if (i > from && y > centers[i]) { to = Math.max(to, i); }
  }
  return to;
}

/** Element von Index a nach b verschieben (neues Array). */
export function moveItem(arr, a, b) {
  const out = arr.slice();
  const [x] = out.splice(a, 1);
  out.splice(b, 0, x);
  return out;
}

export function makeReorderable(list, { item, handle, onDrop }) {
  let drag = null;
  const rows = () => [...list.querySelectorAll(item)];
  const down = (e) => {
    const h = e.target.closest(handle);
    if (!h || !list.contains(h) || (e.button !== undefined && e.button !== 0)) return;
    const row = h.closest(item);
    const all = rows();
    const from = all.indexOf(row);
    if (from < 0) return;
    e.preventDefault();
    const rects = all.map((r) => r.getBoundingClientRect());
    drag = { id: e.pointerId, row, all, from, to: from, y0: e.clientY, rects, h: rects[from].height + parseFloat(getComputedStyle(list).rowGap || 0) };
    row.classList.add('is-dragging');
    list.classList.add('is-reordering');
    for (const r of all) if (r !== row) r.style.transition = reducedMotion() ? 'none' : 'transform var(--md-motion-spatial-fast-duration) var(--md-motion-spatial-fast)';
    try { h.setPointerCapture(e.pointerId); } catch {}
  };
  const move = (e) => {
    if (!drag || e.pointerId !== drag.id) return;
    e.preventDefault();
    const dy = e.clientY - drag.y0;
    drag.row.style.transform = `translateY(${dy}px)`;
    const centers = drag.rects.map((r) => r.top + r.height / 2);
    const to = targetIndex(centers, drag.from, centers[drag.from] + dy);
    if (to !== drag.to) {
      drag.to = to;
      drag.all.forEach((r, i) => {
        if (r === drag.row) return;
        let shift = 0;
        if (drag.from < to && i > drag.from && i <= to) shift = -drag.h;
        if (drag.from > to && i < drag.from && i >= to) shift = drag.h;
        r.style.transform = shift ? `translateY(${shift}px)` : '';
      });
    }
  };
  const up = (e) => {
    if (!drag || e.pointerId !== drag.id) return;
    const d = drag; drag = null;
    for (const r of d.all) { r.style.transform = ''; r.style.transition = ''; }
    d.row.classList.remove('is-dragging');
    list.classList.remove('is-reordering');
    if (d.to !== d.from && onDrop) onDrop(d.from, d.to);
  };
  list.addEventListener('pointerdown', down);
  addEventListener('pointermove', move, { passive: false });
  addEventListener('pointerup', up);
  addEventListener('pointercancel', up);
  return () => {
    list.removeEventListener('pointerdown', down);
    removeEventListener('pointermove', move); removeEventListener('pointerup', up); removeEventListener('pointercancel', up);
  };
}
